import request from '@/utils/request'

let UserUpgradeApi = {
  /*获取基础设置*/
  getData(data, errorback) {
    return request._post('/shop/plus.userupgrade.Index/index', data, errorback);
  },
  /*保存基础设置*/
  saveData(data, errorback) {
    return request._post('/shop/plus.userupgrade.Index/edit', data, errorback);
  },
}
export default UserUpgradeApi;



// WEBPACK FOOTER //
// ./src/api/plus/userupgrade.js